<template>
  <v-content>
    <v-container fluid>
      <v-card class="elevation-5">
        <v-toolbar dense dark color="deep-orange" elevation="2">
          <v-toolbar-title>Resultados</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          <v-btn
            small
            :loading="loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="refresh()"
          >
            Actualizar
            <v-icon right>mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            small
            :loading="loading"
            elevation="0"
            color="deep-orange"
            outlined
            class="mx-2"
            @click="dialogFilters = true"
          >
            Filtros
            <v-icon right>mdi-filter</v-icon>
          </v-btn>
          <!--<v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" @click="viewLogo()">
            Logo
            <v-icon right>mdi-image</v-icon>
          </v-btn>
          <v-btn small :loading="loading" elevation="0" color="deep-orange" outlined class="mx-2" :disabled="selected.length <= 1" @click="downloadReport(selected)">
            Reportes (ZIP)
            <v-icon right>mdi-download</v-icon>
          </v-btn>-->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="mx-2"
            single-line
            hide-details
            maxlength="150"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          :loading="loading"
          :search="search"
          fixed-header
          height="550px"
          :footer-props="{ 'items-per-page-text': 'Elementos por página' }"
          :items-per-page="-1"
          item-key="id"
          :page.sync="page"
          class="elevation-1"
        >
          <v-progress-linear
            slot="progress"
            color="blue"
            indeterminate
          ></v-progress-linear>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top
              ><template v-slot:activator="{ on, attrs }"
                ><v-icon
                  class="mx-2"
                  size="22"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  :disabled="loading"
                  @click="detail(item)"
                  >mdi-eye</v-icon
                ></template
              ><span>Ver detalle</span></v-tooltip
            >
            <!--<v-tooltip top><template v-slot:activator="{ on, attrs }"><v-icon class="mx-2" size="22" color="primary" dark v-bind="attrs" v-on="on" :disabled="loading" @click="downloadReport([item])">mdi-file</v-icon></template><span>Descargar reporte</span></v-tooltip>-->
          </template>
          <template v-slot:footer.page-text="props">
            Página {{ props.pageStart }} - {{ props.pageStop }} de
            {{ props.itemsLength }}
          </template>
          <template v-slot:no-data> No hay información disponible </template>
          <template v-slot:no-results> No se obtuvieron resultados </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogFilters" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Filtros</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="clearFilters()">
              Reiniciar
              <v-icon right>mdi-minus</v-icon>
            </v-btn>
            <v-btn text small :disabled="loading" @click="closeFilters()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="setFilters()">
              Aceptar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="filters.plaza"
                    :items="plazas"
                    item-value="id"
                    item-text="nombre"
                    label="Plaza"
                    :disabled="loading"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <span>Fecha de inicio de contestación</span>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog
                    ref="startDate"
                    v-model="dialogStartDate"
                    :return-value.sync="filters.fecha_inicio"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.fecha_inicio"
                        label="Fecha inicio"
                        :disabled="loading"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.fecha_inicio"
                      locale="es"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="dialogStartDate = false"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.startDate.save(filters.fecha_inicio)"
                        >Aceptar</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog
                    ref="endDate"
                    v-model="dialogEndDate"
                    :return-value.sync="filters.fecha_fin"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.fecha_fin"
                        label="Fecha fin"
                        :disabled="loading"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.fecha_fin"
                      locale="es"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialogEndDate = false"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.endDate.save(filters.fecha_fin)"
                        >Aceptar</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12">
                  <span>Fecha de registro</span>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog
                    ref="startDateUpd"
                    v-model="dialogStartDateUpd"
                    :return-value.sync="filters.fecha_inicio_act"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.fecha_inicio_act"
                        label="Fecha inicio"
                        :disabled="loading"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.fecha_inicio_act"
                      locale="es"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="dialogStartDateUpd = false"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs.startDateUpd.save(filters.fecha_inicio_act)
                        "
                        >Aceptar</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog
                    ref="endDateUpd"
                    v-model="dialogEndDateUpd"
                    :return-value.sync="filters.fecha_fin_act"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filters.fecha_fin_act"
                        label="Fecha fin"
                        :disabled="loading"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filters.fecha_fin_act"
                      locale="es"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="dialogEndDateUpd = false"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.endDateUpd.save(filters.fecha_fin_act)"
                        >Aceptar</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="filters.encuesta"
                    :items="encuestas"
                    item-value="id"
                    item-text="nombre"
                    label="Encuesta"
                    :disabled="loading"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="filters.supervisor"
                    :items="supervisores"
                    item-value="id"
                    item-text="nombre"
                    label="Supervisor"
                    :disabled="loading"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="filters.promotor"
                    :items="promotores"
                    item-value="id"
                    item-text="nombre"
                    label="Promotor"
                    :disabled="loading"
                  ></v-autocomplete>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogResult"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Detalle del resultado</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row class="pt-5">
              <v-col>
                <v-card class="elevation-5">
                  <v-toolbar dense dark color="deep-orange" elevation="2">
                    <v-toolbar-title>
                      {{
                        selected.length &&
                        selected[0].actividad +
                          " / " +
                          selected[0].encuesta +
                          " / " +
                          selected[0].relacion
                      }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn text small :disabled="loading" @click="cancel()">
                      Cerrar
                      <v-icon right>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="result.search"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                    :headers="result.headers"
                    :items="result.items"
                    :loading="loading"
                    :search="result.search"
                    fixed-header
                    height="550px"
                    :footer-props="{
                      'items-per-page-text': 'Elementos por página',
                    }"
                    :items-per-page="-1"
                    item-key="id"
                    :page.sync="result.page"
                    class="elevation-1"
                    @click:row="showImage"
                  >
                    <v-progress-linear
                      slot="progress"
                      color="blue"
                      indeterminate
                    ></v-progress-linear>
                    <template v-slot:item.opciones="{ item }">
                      {{ item.opciones.length }}
                    </template>
                    <template v-slot:item.respuesta="{ item }">
                      <v-btn
                        v-if="
                          (item.tipo === 'foto' || item.tipo === 'firma') &&
                          item.respuesta !== ''
                        "
                        text
                        small
                        rounded
                        color="blue"
                        dark
                      >
                        Foto
                        <v-icon right>mdi-camera</v-icon>
                      </v-btn>
                      <v-btn
                        v-else-if="
                          (item.tipo === 'foto' || item.tipo === 'firma') &&
                          item.respuesta === ''
                        "
                        text
                        small
                        rounded
                        disabled
                        color="blue"
                      >
                        Foto
                        <v-icon right>mdi-camera</v-icon>
                      </v-btn>
                      <span v-else>{{ item.respuesta }}</span>
                    </template>
                    <template v-slot:footer.page-text="props">
                      Página {{ props.pageStart }} - {{ props.pageStop }} de
                      {{ props.itemsLength }}
                    </template>
                    <template v-slot:no-data>
                      No hay información disponible
                    </template>
                    <template v-slot:no-results>
                      No se obtuvieron resultados
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogImage" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>{{
              result.selected.length &&
              result.selected[0].respuesta !== "" &&
              result.selected[0].respuesta.split("_")[
                result.selected[0].respuesta.split("_").length - 1
              ]
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancelImage()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row align="center" justify="center">
                <img
                  :src="result.imageUrl"
                  style="width: 100%; max-width: 600px"
                />
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLogo" persistent max-width="600px">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title>Actualizar logo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading" @click="cancel()">
              Cerrar
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <v-btn text small :loading="loading" @click="updateLogo()">
              Actualizar
              <v-icon right>mdi-check</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="file"
                    chips
                    small-chips
                    show-size
                    label="Seleccionar imagen..."
                    accept="image/png"
                    :disabled="loading"
                    required
                    @change="getImage()"
                    dense
                    outlined
                  ></v-file-input>
                </v-col>
                <v-col v-if="logo" cols="12">
                  <v-card>
                    <v-card-text>
                      <v-img :src="logo" max-height="500" contain />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar
        v-model="success"
        color="success"
        :timeout="2500"
        bottom
        right
      >
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import services from "@/utils/services";
import moment from "moment";
import downloadjs from "downloadjs";
import Vue from "vue";

export default {
  name: "resultados",
  data: () => ({
    loading: false,
    error: false,
    msgError: "",
    success: false,
    msgSuccess: "",
    search: "",
    headers: [
      {
        text: "Actividad",
        align: "center",
        sortable: false,
        value: "actividad",
      },
      { text: "Encuesta", align: "center", sortable: false, value: "encuesta" },
      { text: "Tienda", align: "center", sortable: false, value: "tienda" },
      {
        text: "Relación Tiendas/Empresas",
        align: "center",
        sortable: false,
        value: "relacion",
      },
      {
        text: "Coordenadas",
        align: "center",
        sortable: false,
        value: "coordenadas",
      },
      {
        text: "Fecha inicio contestación",
        align: "center",
        sortable: false,
        value: "fecha_inicio_contestacion",
      },
      {
        text: "Fecha fin contestación",
        align: "center",
        sortable: false,
        value: "fecha_fin_contestacion",
      },
      {
        text: "Usuario",
        align: "center",
        sortable: false,
        value: "usuario_registro",
      },
      {
        text: "Fecha Registro",
        align: "center",
        sortable: false,
        value: "fecha_registro",
      },
      { text: "Acciones", align: "center", sortable: false, value: "actions" },
    ],
    items: [],
    selected: [],
    plazas: [],
    encuestas: [],
    supervisores: [],
    promotores: [],
    filters: {
      plaza: "",
      fecha_inicio: "",
      fecha_fin: "",
      fecha_inicio_act: "",
      fecha_fin_act: "",
      encuesta: "",
      supervisor: "",
      promotor: "",
    },
    file: null,
    logo: null,
    page: 1,
    result: {
      search: "",
      headers: [
        { text: "#", align: "center", sortable: false, value: "id" },
        {
          text: "Idexterno",
          align: "center",
          sortable: false,
          value: "idexterno",
        },
        { text: "Pregunta", align: "center", sortable: false, value: "nombre" },
        {
          text: "No. opciones",
          align: "center",
          sortable: false,
          value: "opciones",
        },
        { text: "Tipo", align: "center", sortable: false, value: "tipo" },
        {
          text: "Respuesta",
          align: "center",
          sortable: false,
          value: "respuesta",
        },
      ],
      items: [],
      selected: [],
      page: 1,
      image: "",
      imageUrl: "",
      type: "",
    },
    dialogFilters: false,
    dialogStartDate: false,
    dialogEndDate: false,
    dialogStartDateUpd: false,
    dialogEndDateUpd: false,
    dialogResult: false,
    dialogImage: false,
    dialogLogo: false,
  }),
  mounted() {
    this.refresh();
    this.dialogFilters = true;
  },
  methods: {
    refresh() {
      this.loading = true;
      let data = {
        filtros: JSON.stringify(this.filters),
      };
      services
        .ws("get", "resultados", data)
        .then((res) => {
          if (res.ok) {
            this.items = res.data.resultados;
            this.plazas = res.data.plazas;
            this.encuestas = res.data.encuestas;
            this.supervisores = res.data.supervisores;
            this.promotores = res.data.promotores;
            this.selected = [];
            this.page = 1;
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearFilters() {
      for (let key in this.filters) {
        this.filters[key] = "";
      }
    },
    closeFilters() {
      this.dialogFilters = false;
    },
    setFilters() {
      if (
        this.filters.fecha_inicio_act === "" ||
        this.filters.fecha_fin_act === ""
      ) {
        this.error = true;
        this.msgError =
          "Debe establecer el filtro de fechas (Fecha de registro)";
      } else if (
        moment(this.filters.fecha_fin_act, "YYYY-MM-DD").diff(
          moment(this.filters.fecha_inicio_act, "YYYY-MM-DD")
        ) < 0
      ) {
        this.error = true;
        this.msgError =
          "La fecha fin debe ser mayor o igual que la fecha inicio (Fecha de registro)";
      } else {
        this.loading = true;
        let data = {
          filtros: JSON.stringify(this.filters),
        };
        services
          .ws("get", "resultados", data)
          .then((res) => {
            if (res.ok) {
              this.items = res.data.resultados;
              this.plazas = res.data.plazas;
              this.encuestas = res.data.encuestas;
              this.supervisores = res.data.supervisores;
              this.promotores = res.data.promotores;
              this.selected = [];
              this.page = 1;
              this.closeFilters();
            } else {
              this.error = true;
              this.msgError = res.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    detail(val) {
      this.loading = true;
      this.selected[0] = val;
      let id = this.selected[0].id;
      services
        .ws("get", "detalleResultado", { id })
        .then((res) => {
          if (res.ok) {
            this.result.items = res.data.respuestas;
            for (let i = 0; i < this.result.items.length; i++) {
              this.result.items[i].id = i + 1;
              if (
                !("respuesta" in this.result.items[i]) ||
                this.result.items[i].respuesta === null
              ) {
                this.result.items[i].respuesta = "";
              }
            }
            this.dialogResult = true;
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      this.result.search = "";
      this.result.items = [];
      this.result.selected = [];
      this.result.page = 1;
      this.selected = [];
      this.file = null;
      this.logo = null;
      this.dialogResult = false;
      this.dialogLogo = false;
    },
    showImage(val) {
      if (
        (val.tipo === "foto" || val.tipo === "firma") &&
        val.respuesta !== ""
      ) {
        this.loading = true;
        this.result.selected[0] = val;
        let arr = this.result.selected[0].respuesta.split("_");
        let actividad = arr[0];
        let sub_folder = "";
        let nombre = arr[arr.length - 1];
        if (arr.length >= 3) {
          for (let i = 1; i < arr.length - 1; i++) {
            sub_folder = "/" + arr[1];
          }
        }

        // Usar axios directamente para obtener la imagen como binario
        let jwt = Vue.prototype.$session.get("jwt");
        let params = new URLSearchParams({
          actividad,
          sub_folder,
          nombre,
          binario: "true",
        });

        this.axios({
          url: `${services.routes.imagen}?${params.toString()}`,
          method: "GET",
          headers: {
            Authorization: "Bearer " + jwt,
          },
          responseType: "blob",
        })
          .then((response) => {
            // Revocar URL anterior si existe para liberar memoria
            if (this.result.imageUrl) {
              URL.revokeObjectURL(this.result.imageUrl);
            }
            // Crear Object URL desde el blob
            this.result.imageUrl = URL.createObjectURL(response.data);
            this.result.type = response.headers["content-type"] || "image/jpeg";
            this.dialogImage = true;
          })
          .catch((err) => {
            console.error("Error obteniendo imagen:", err);
            this.error = true;
            this.msgError = "La imagen no fue obtenida";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cancelImage() {
      // Revocar Object URL para liberar memoria
      if (this.result.imageUrl) {
        URL.revokeObjectURL(this.result.imageUrl);
        this.result.imageUrl = "";
      }
      this.result.image = "";
      this.result.type = "";
      this.dialogImage = false;
    },
    downloadReport(id) {
      this.loading = true;
      let jwt = Vue.prototype.$session.get("jwt");
      let headers = {
        Authorization: "Bearer " + jwt,
      };
      let data = { id: id.map((e) => e.id) };
      let name =
        id.length > 1 ? "Reportes.zip" : `${id[0].heets} - ${id[0].tienda}.pdf`;
      let contentType = id.length > 1 ? "application/zip" : "application/pdf";
      this.axios({
        url: services.routes.reporteResultado,
        method: "POST",
        headers: headers,
        data: data,
        responseType: "blob",
      })
        .then((response) => {
          downloadjs(response.data, name, contentType);
        })
        .catch(() => {
          this.error = true;
          this.msgError = "El reporte no pudo ser generado";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewLogo() {
      this.loading = true;
      let jwt = Vue.prototype.$session.get("jwt");
      let headers = {
        Authorization: "Bearer " + jwt,
      };
      this.axios({
        url: services.routes.logo,
        method: "GET",
        headers: headers,
      })
        .then((response) => {
          (this.logo = response.data
            ? "data:image/png;base64," + response.data
            : null),
            (this.dialogLogo = true);
        })
        .catch(() => {
          this.error = true;
          this.msgError = "El logo no fue obtenido";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getImage() {
      if (this.file) {
        let fr = new FileReader();
        let file = this.file;
        let size = file.size;
        if (size <= 1000000) {
          fr.onload = () => {
            this.logo = fr.result;
          };
          fr.onerror = () => {
            this.loading = false;
            this.file = null;
            this.error = true;
            this.msgError = "El archivo no fue leído correctamente";
          };
          fr.readAsDataURL(file);
        } else {
          this.error = true;
          this.msgError = "El archivo ha excedido el límite permitido (1 MB)";
        }
      }
    },
    updateLogo() {
      this.loading = true;
      let jwt = Vue.prototype.$session.get("jwt");
      let headers = {
        Authorization: "Bearer " + jwt,
      };
      let data = {
        logo: this.logo ? this.logo.split(",")[1] : null,
      };
      this.axios({
        url: services.routes.actualizarLogo,
        method: "POST",
        headers: headers,
        data: data,
      })
        .then(() => {
          this.cancel();
          this.success = true;
          this.msgSuccess = "El logo fue actualizado";
        })
        .catch(() => {
          this.error = true;
          this.msgError = "El logo no fue actualizado";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
